/**
 * Helpers clôture de session académique.
 */

export function isSessionCloturee(
	session: { est_cloturee?: boolean; cloturee_at?: string | null; etat?: string | null } | null | undefined
): boolean {
	if (!session) return false
	if (session.est_cloturee === true) return true
	if (session.cloturee_at) return true
	const etat = (session.etat || '').toLowerCase()
	return etat.includes('terminé') || etat === 'termine'
}

export function canMutateClosedSession(isAdmin: boolean, isSuperAdmin: boolean): boolean {
	return isAdmin || isSuperAdmin
}

/** États sélectionnables dans les formulaires session (hors clôture formelle). */
export const SESSION_ETATS_FORMULAIRE = ['prévu', 'en cours', 'annulé'] as const

export function sessionEtatFormOptions(currentEtat?: string | null) {
	const options = [...SESSION_ETATS_FORMULAIRE]
	// Si déjà terminé (legacy), garder visible en lecture mais déconseiller
	if (currentEtat && (currentEtat.includes('terminé') || currentEtat === 'termine')) {
		return [...options, 'terminé' as const]
	}
	return options
}
